var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessSmallFilled = function SvgSuccessSmallFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#53CA48",
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M6 10.012 8.66 13 14 7"
  }))));
};
export { SvgSuccessSmallFilled as ReactComponent };
export default "data:image/svg+xml,%3csvg viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Group-8' transform='translate(0.000000, -1.000000)'%3e %3cg id='Group-7' transform='translate(0.000000, 1.000000)'%3e %3crect id='Rectangle-Copy-60' fill='%2353CA48' x='0' y='0' width='20' height='20' rx='10'%3e%3c/rect%3e %3cpolyline id='Path-2-Copy-5' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='square' points='6 10.011816 8.65965536 13 14 7'%3e%3c/polyline%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";